import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { trackEntityById } from 'projects/core/src/public-api';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';

@Component({
  selector: 'app-project-copy-dialog',
  templateUrl: './project-copy-dialog.component.html',
  styleUrls: ['./project-copy-dialog.component.scss']
})
export class ProjectCopyDialogComponent implements OnInit {

  project: ShortProject;
  projectNames = [];

  submitLoading: boolean;

  trackEntityById = trackEntityById;

  constructor(
    private snackBar: MatSnackBar,
    private projectService: ProjectService,
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<ProjectCopyDialogComponent>,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      project: ShortProject
    }) {
    this.project = data.project;

    this.projectNames = [this.project.name + ' - Unit 1']
  }

  ngOnInit(): void {

  }

  copyProjects() {
    this.submitLoading = true;

    this.projectNames.forEach((name, index) => {
      if(name === '') {
        this.projectNames.splice(index, 1)
      }
    })

    this.projectService.copyProject(this.project.id, this.projectNames).subscribe(email => {
      this.miscSnackBarService.openSuccessSnackBar('Success! New projects will appear within 2 minutes.')
      this.submitLoading = false;
      this.dialogRef.close('Success!');

    }, error => {
      this.miscSnackBarService.openErrorSnackBar('Error!')
      this.submitLoading = false;
    })
  }

  addField() {
    this.projectNames.push(this.project.name + ' - Unit ' + (this.projectNames.length + 1))
  }

  deleteField(index: number) {
    if(!this.submitLoading) {
      this.projectNames.splice(index, 1)
    }
  }

  openSnackBar(message: string, type: string) {
    let panelClass = 'client-snackbar';

    if(type === 'Error!') {
      panelClass = 'error-snackbar'
    }

    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass,
      verticalPosition: 'top',
    });
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

}
